import React from 'react';
import { PropertyValuationData } from '../../../../types/valuation';
import { RentalAnalysis } from '../RentalAnalysis';
import { TaxInformation } from '../TaxInformation';

interface AdditionalAnalysisProps {
  propertyData: PropertyValuationData;
  transformValue: (value: any) => number;
}

export const AdditionalAnalysis: React.FC<AdditionalAnalysisProps> = ({
  propertyData,
  transformValue
}) => {
  return (
    <>
      <RentalAnalysis
        propertyData={{
          estimatedValue: transformValue(propertyData.estimatedValue),
          demographics: propertyData.demographics
        }}
        className="mb-8"
      />

      <TaxInformation
        propertyData={{
          taxInfo: propertyData.taxInfo
        }}
        className="mb-8"
      />
    </>
  );
};
